import { CurrentUser } from '@uplift/api';
import { AdminRole } from '@uplift/types';

export const isRestricted = (me: CurrentUser) => me.role === 'patient' && !!me.rules?.nonpayment;
export const isAdmin = (me: CurrentUser) => me.role === 'superadmin';
export const isRegularAdmin = (me: CurrentUser) => me.adminRole === AdminRole.admin || me.adminRole === AdminRole.superAdmin;
export const isSuperAdmin = (me: CurrentUser) => me.adminRole === AdminRole.superAdmin;
export const isDeveloper = (me: CurrentUser) => me.adminRole === AdminRole.developer;
export const isHigherEdAdmin = (me: CurrentUser) => me.adminRole === AdminRole.higherEdAdmin;
export const isExternalAdmin = (me: CurrentUser) => me.role === 'external_admin';
export const isBillingSpecialist = (me: CurrentUser) => me.adminRole === AdminRole.billingSpecialist;
export const isCredentiallingSpecialist = (me: CurrentUser) => me.adminRole === AdminRole.credentiallingSpecialist;
